// src/redux/companyProspect/companyProspectApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Create Company Prospect
export const createCompanyProspectAPI = async (prospectData) => {
  try {
    const endpoint = endpoints.createCompanyProspect;
    const response =
      prospectData instanceof FormData
        ? await apiService.postFormData(endpoint, prospectData)
        : await apiService.post(endpoint, prospectData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Prospect Generated URL
export const getCompanyProspectGeneratedUrlAPI = async (companyId) => {
  try {
    const params = { company_id: companyId };
    const response = await apiService.get(endpoints.getCompanyUrl, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Generate Company Prospect URL
export const generateCompanyProspectUrlAPI = async (prospectData) => {
  try {
    const response =
      prospectData instanceof FormData
        ? await apiService.postFormData(
            endpoints.getCompanyProspectGeneratedUrl,
            prospectData
          )
        : await apiService.post(
            endpoints.getCompanyProspectGeneratedUrl,
            prospectData
          );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Prospect Listing
export const getCompanyProspectListingAPI = async ({
  page = 1,
  limit = 10,
  search = "",
} = {}) => {
  try {
    const params = { page, limit, search };
    const response = await apiService.get(
      endpoints.getCompanyProspectListing,
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Prospect Detail by ID
export const getCompanyProspectDetailAPI = async (companyId) => {
  try {
    const endpoint = endpoints.getCompanyProspectDetail.replace(
      "{company_id}",
      companyId
    );
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Company Prospect
export const updateCompanyProspectAPI = async (companyId, prospectData) => {
  try {
    const endpoint = endpoints.updateCompanyProspect.replace(
      "{company_id}",
      companyId
    );
    const response =
      prospectData instanceof FormData
        ? await apiService.patchFormData(endpoint, prospectData)
        : await apiService.put(endpoint, prospectData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Company Prospect
export const deleteCompanyProspectAPI = async (companyId) => {
  try {
    const endpoint = endpoints.deleteCompanyProspect.replace(
      "{company_id}",
      companyId
    );
    const response = await apiService.delete(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Employees
export const getCompanyEmployeesAPI = async ({
  companyId,
  page = 1,
  limit = 10,
  search = "",
} = {}) => {
  try {
    const endpoint = endpoints.getCompanyEmployees.replace(
      "{company_id}",
      companyId
    );
    const params = { page, limit, search };
    const response = await apiService.get(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Employee Detail
export const getCompanyEmployeeDetailAPI = async (companyId, employeeId) => {
  try {
    const endpoint = endpoints.getCompanyEmployeeDetail
      .replace("{company_id}", companyId)
      .replace("{candidate_id}", employeeId);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Convert Company Prospect
export const convertCompanyProspectAPI = async (companyId, prospectData) => {
  try {
    const endpoint = endpoints.convertCompanyProspect.replace(
      "{company_id}",
      companyId
    );
    const response =
      prospectData instanceof FormData
        ? await apiService.postFormData(endpoint, prospectData)
        : await apiService.post(endpoint, prospectData);
    return response.data;
  } catch (error) {
    throw error;
  }
};